export const movieItems = [
  {
    id: 'film-01',
    category: 'movie',
    title: '星海回声',
    subtitle: 'Echoes of the Star Sea',
    year: 2026,
    region: '中国大陆',
    genres: ['科幻', '剧情'],
    rating: 8.7,
    director: '陈行舟',
    cast: ['林澈', '许南歌', '周牧'],
    duration: '132分钟',
    popularity: 98,
    featured: true,
    summary: '一名深海声呐工程师在废弃空间站里，听见了三十年前自己的求救信号。',
    synopsis:
      '近未来的地球资源枯竭，深海声呐工程师沈砚被派往废弃多年的「回声」空间站做最后一次信号回收。在三个月无人值守的孤独作业中，他反复捕捉到一段来自三十年前的求救广播，而那声音正是他自己。为了弄清这段信号背后的真相，沈砚必须在空间站坠毁前，把时间与记忆之间的裂缝彻底缝合。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20artwork%2C%20lone%20figure%20in%20a%20white%20spacesuit%20floating%20before%20a%20vast%20derelict%20space%20station%2C%20deep%20indigo%20night%20sky%20with%20a%20single%20amber%20planet%2C%20moody%20volumetric%20lighting%2C%20no%20text%2C%20vertical%20composition%2C%20muted%20teal%20and%20warm%20amber%20accents&width=480&height=720&seq=poster-film-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20derelict%20space%20station%20drifting%20above%20a%20dark%20ocean%20planet%2C%20deep%20indigo%20and%20teal%20tones%2C%20faint%20amber%20rim%20light%2C%20atmospheric%20haze%2C%20moody%20sci-fi%20film%20still%2C%20no%20text&width=1600&height=900&seq=hero-film-01&orientation=landscape',
  },
  {
    id: 'film-02',
    category: 'movie',
    title: '长夜列车',
    subtitle: 'The Long Night Train',
    year: 2025,
    region: '中国大陆',
    genres: ['悬疑', '犯罪'],
    rating: 8.4,
    director: '陆崎',
    cast: ['程亦川', '白露', '韩野'],
    duration: '118分钟',
    popularity: 94,
    featured: true,
    summary: '一列驶向边境的夜班列车，八名乘客，只有七张车票是真实的。',
    synopsis:
      '冬至前夜，开往边境小城的 K1127 次列车在暴雪中晚点六小时。乘警老周在例行查票时发现，八名乘客中有一人使用了一个根本不存在的身份证号。随着车厢里的灯一盏盏熄灭，每个人藏在行李里的秘密开始浮出水面，而真凶或许一直坐在他们中间，等待列车驶入无人区的那一刻。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%20artwork%2C%20a%20lone%20train%20carriage%20lit%20by%20cold%20blue%20windows%2C%20heavy%20snow%20outside%2C%20silhouette%20of%20a%20man%20in%20a%20long%20coat%2C%20deep%20navy%20and%20smoky%20gray%20palette%2C%20no%20text%2C%20vertical%20composition%2C%20moody%20atmospheric%20lighting&width=480&height=720&seq=poster-film-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20night%20scene%20of%20an%20old%20passenger%20train%20crossing%20a%20snowy%20plain%2C%20glowing%20windows%20against%20deep%20blue%20darkness%2C%20heavy%20snowfall%2C%20mysterious%20crime%20film%20still%2C%20no%20text&width=1600&height=900&seq=hero-film-02&orientation=landscape',
  },
  {
    id: 'film-03',
    category: 'movie',
    title: '山海拾光',
    subtitle: 'Light Between Mountains',
    year: 2025,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    rating: 9.1,
    director: '苏岑',
    cast: ['何秋生', '许知微', '陈一诺'],
    duration: '126分钟',
    popularity: 92,
    featured: true,
    summary: '退休的灯塔看守人带着孙女回到岛上，用一台旧相机重新记录被遗忘的渔村。',
    synopsis:
      '老周在岛上守了四十年灯塔，退休那天，他带着从未见过海的孙女回到渔村。村子已经空了，只剩下一台发霉的海鸥相机和相册里褪色的脸。祖孙俩决定把整座村庄拍下来，一张一张寄给散落在各地的老邻居。在海风与快门声里，一段被时代轻轻放下的记忆，重新被人拾起。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20artwork%2C%20elderly%20fisherman%20and%20a%20young%20girl%20standing%20on%20a%20rocky%20shore%20at%20dusk%2C%20distant%20lighthouse%20beam%2C%20warm%20amber%20sunset%20over%20cool%20blue%20sea%2C%20no%20text%2C%20vertical%20composition%2C%20soft%20film%20grain&width=480&height=720&seq=poster-film-03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Quiet%20cinematic%20coastal%20dusk%2C%20old%20lighthouse%20on%20a%20rocky%20island%2C%20abandoned%20fishing%20village%20in%20soft%20mist%2C%20warm%20orange%20horizon%20against%20deep%20blue%20sea%2C%20gentle%20waves%2C%20no%20text&width=1600&height=900&seq=hero-film-03&orientation=landscape',
  },
  {
    id: 'film-04',
    category: 'movie',
    title: '都市第九格',
    subtitle: 'The Ninth Block',
    year: 2024,
    region: '中国大陆',
    genres: ['喜剧', '爱情'],
    rating: 7.8,
    director: '余乐',
    cast: ['江小鱼', '唐可', '方南'],
    duration: '112分钟',
    popularity: 88,
    summary: '两个抢同一间出租屋的陌生人，被迫开始了一场二十四小时的合租实验。',
    synopsis:
      '北漂第七年，编剧江小鱼终于找到一个采光极好的出租屋，却在签合同的同一分钟，遇上了同样来看房的脱口秀演员唐可。房东临时失联，合同只剩一份，两人干脆约定：谁先在这个房间里写出被采纳的稿子，谁就留下。二十四小时、一台旧电脑、两杯凉掉的咖啡，一场关于梦想与房租的拉锯战就此开场。',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20urban%20romantic%20comedy%20poster%20artwork%2C%20two%20young%20people%20sitting%20on%20a%20bare%20apartment%20floor%20surrounded%20by%20moving%20boxes%2C%20city%20window%20light%2C%20playful%20chemistry%2C%20soft%20amber%20and%20cream%20tones%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Modern%20city%20apartment%20interior%20at%20golden%20hour%2C%20cardboard%20boxes%20and%20a%20laptop%20on%20the%20floor%2C%20big%20window%20overlooking%20dense%20skyline%2C%20warm%20amber%20light%20with%20cool%20blue%20shadows%2C%20no%20text&width=1600&height=900&seq=hero-film-04&orientation=landscape',
  },
  {
    id: 'film-05',
    category: 'movie',
    title: '风起潮间带',
    subtitle: 'Tidewalker',
    year: 2026,
    region: '中国大陆',
    genres: ['冒险', '剧情'],
    rating: 8.2,
    director: '郑野',
    cast: ['雷远', '沈星野', '罗海'],
    duration: '140分钟',
    popularity: 90,
    summary: '三名海洋测绘员被困潮间带，必须在涨潮前走出这片会移动的迷宫。',
    synopsis:
      '为了完成一片新海域的测绘，三名测绘员在退潮时踏上了潮间带。突如其来的风暴摧毁了通讯设备，也打乱了潮汐表。他们只有六个小时，在海水重新覆盖这片滩涂之前找到那条被当地人称作「骨线」的旧路。随着体力与信任一同流失，三人中有人开始怀疑：这次任务从一开始就不该被批准。',
    poster:
      'https://readdy.ai/api/search-image?query=Adventure%20drama%20movie%20poster%20artwork%2C%20three%20figures%20walking%20across%20a%20vast%20mirror-like%20tidal%20flat%20under%20a%20storm%20sky%2C%20reflections%20of%20clouds%2C%20deep%20slate%20blue%20and%20silver%20palette%2C%20no%20text%2C%20vertical%20composition%2C%20epic%20scale&width=480&height=720&seq=poster-film-05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20aerial%20cinematic%20shot%20of%20an%20enormous%20tidal%20flat%20at%20low%20tide%2C%20mirror%20reflections%20of%20a%20dramatic%20storm%20sky%2C%20tiny%20human%20figures%20in%20the%20distance%2C%20cool%20steel%20blue%20tones%20with%20amber%20horizon%2C%20no%20text&width=1600&height=900&seq=hero-film-05&orientation=landscape',
  },
  {
    id: 'film-06',
    category: 'movie',
    title: '雾城档案',
    subtitle: 'Files of the Fog City',
    year: 2023,
    region: '中国香港',
    genres: ['犯罪', '悬疑'],
    rating: 8.5,
    director: '麦兆辉',
    cast: ['邓世昌', '梁若琳', '黄子澄'],
    duration: '124分钟',
    popularity: 85,
    summary: '一份被封存二十年的档案重新开启，牵出警队内部最不愿提及的旧案。',
    synopsis:
      '重案组新人梁若琳在整理旧档案时，发现一宗二十年前被定性为意外的案子，卷宗照片里出现了她父亲年轻时的背影。随着调查深入，她发现当年的办案警员如今已是警队高层，而每一位知情者都在用沉默守护同一个秘密。雾从海面漫上城市，真相却在档案室里慢慢显影。',
    poster:
      'https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20thriller%20poster%20artwork%2C%20detective%20silhouette%20under%20a%20flickering%20street%20lamp%20in%20dense%20fog%2C%20old%20file%20folder%20in%20hand%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20navy%20and%20amber%20palette%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-06&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20night%20view%20of%20a%20foggy%20harbor%20city%2C%20dense%20neon%20signs%20blurring%20in%20mist%2C%20wet%20streets%2C%20deep%20blue%20shadows%20with%20warm%20orange%20reflections%2C%20crime%20film%20still%2C%20no%20text&width=1600&height=900&seq=hero-film-06&orientation=landscape',
  },
  {
    id: 'film-07',
    category: 'movie',
    title: '霓虹尽头',
    subtitle: 'End of Neon',
    year: 2024,
    region: '中国香港',
    genres: ['动作', '犯罪'],
    rating: 7.9,
    director: '林振邦',
    cast: ['陈汉声', '李慕', '张一霆'],
    duration: '109分钟',
    popularity: 83,
    summary: '替人收债半生的街头混混，决定最后一次替自己讨一个说法。',
    synopsis:
      '阿岳在旺角替人收了十五年债，从没问过为什么。直到某天，他在名单上看见了自己老邻居的名字，也第一次听说了那笔钱背后的故事。霓虹灯下的街区即将拆迁，旧秩序正在崩塌，他决定用自己唯一擅长的方式，为这条街、也为过去的自己，做最后一件事。',
    poster:
      'https://readdy.ai/api/search-image?query=Action%20crime%20poster%20artwork%2C%20a%20man%20in%20a%20windbreaker%20standing%20in%20a%20narrow%20alley%20of%20neon%20signs%2C%20rain%20and%20steam%2C%20orange%20and%20magenta%20glow%20against%20deep%20navy%20darkness%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-07&orientation=portrait',
  },
  {
    id: 'film-08',
    category: 'movie',
    title: '空港以西',
    subtitle: 'West of the Terminal',
    year: 2022,
    region: '美国',
    genres: ['剧情', '传记'],
    rating: 8.8,
    director: 'Daniel Reeve',
    cast: ['Martin Cole', 'Eva Hansley', 'Owen Pike'],
    duration: '136分钟',
    popularity: 80,
    summary: '一位机场行李调度员，用三十年时间把走失的行李送回了它们的主人。',
    synopsis:
      '在大型机场的地下三层，行李调度员弗兰克工作了三十年。他记得每一件走失行李的编号，也记得那些来认领的人脸上的表情。当自动分拣系统即将取代整支人工团队，弗兰克决定在退休前，把仓库里最后三百件无人认领的行李全部送回家。这是一段关于平凡坚持与告别的温柔纪录。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20biographical%20drama%20poster%20artwork%2C%20middle-aged%20man%20in%20a%20uniform%20standing%20among%20rows%20of%20vintage%20suitcases%20in%20a%20dim%20airport%20basement%2C%20single%20overhead%20lamp%2C%20muted%20steel%20blue%20and%20amber%20tones%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-08&orientation=portrait',
  },
  {
    id: 'film-09',
    category: 'movie',
    title: '第七轨道',
    subtitle: 'Orbit Seven',
    year: 2025,
    region: '美国',
    genres: ['科幻', '惊悚'],
    rating: 8.1,
    director: 'Nora Bishop',
    cast: ['Caleb Stone', 'Iris Vaughn', 'Dylan Marsh'],
    duration: '121分钟',
    popularity: 91,
    featured: true,
    summary: '空间站第七轨道突然偏离，宇航员发现导航系统正在执行一份不存在的手册。',
    synopsis:
      '国际空间站第七轨道在例行调整中突然偏离预定航线，地面指挥中心失去响应。留守的三名宇航员发现，导航系统正在执行一套从未被批准的应急预案，而这套预案的签署人，是二十年前在一次事故中失踪的指挥官。当氧气与时间一同倒数，他们必须在服从程序和相信直觉之间做出选择。',
    poster:
      'https://readdy.ai/api/search-image?query=Sci-fi%20thriller%20poster%20artwork%2C%20astronaut%20helmet%20reflecting%20a%20broken%20space%20station%20corridor%2C%20red%20emergency%20light%20and%20cold%20blue%20shadows%2C%20tense%20cinematic%20composition%2C%20no%20text%2C%20vertical%20format&width=480&height=720&seq=poster-film-09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Space%20station%20interior%20corridor%20with%20blinking%20red%20alarm%20lights%2C%20circular%20window%20showing%20earth%2C%20cold%20blue%20metal%20surfaces%2C%20cinematic%20sci-fi%20thriller%20still%2C%20no%20text&width=1600&height=900&seq=hero-film-09&orientation=landscape',
  },
  {
    id: 'film-10',
    category: 'movie',
    title: '无声证词',
    subtitle: 'Silent Witness',
    year: 2024,
    region: '美国',
    genres: ['悬疑', '律政'],
    rating: 8.6,
    director: 'Aaron Wells',
    cast: ['Grace Lin', 'Peter Doyle', 'Naomi Frost'],
    duration: '128分钟',
    popularity: 87,
    summary: '一场没有目击者的谋杀案，唯一的证人是位无法开口的聋哑画师。',
    synopsis:
      '知名建筑商在家中遇害，现场没有指纹、没有监控，只有一幅未完成的素描。画师是一名聋哑女孩，她画下了案发当晚窗外的所有细节。年轻辩护律师接下这桩几乎必败的案子，用手语一点点拼出那晚的真相，也逐渐发现，沉默本身可能就是最锋利的证词。',
    poster:
      'https://readdy.ai/api/search-image?query=Legal%20thriller%20movie%20poster%20artwork%2C%20a%20young%20woman%20holding%20a%20charcoal%20sketch%20in%20a%20dark%20courtroom%2C%20single%20shaft%20of%20light%2C%20hands%20in%20focus%2C%20muted%20charcoal%20gray%20and%20warm%20amber%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-10&orientation=portrait',
  },
  {
    id: 'film-11',
    category: 'movie',
    title: '野火季',
    subtitle: 'Fire Season',
    year: 2023,
    region: '美国',
    genres: ['剧情', '西部'],
    rating: 8.0,
    director: 'Sam Calloway',
    cast: ['Roy Mercer', 'Lena Hart', 'Bo Whitaker'],
    duration: '134分钟',
    popularity: 74,
    summary: '干旱的牧场上，一对父子在扑灭野火的同时，也点燃了积压十年的矛盾。',
    synopsis:
      '连续三年干旱，让西部牧场的草场只剩下一层灰。老牧场主罗伊坚持留下，儿子凯尔却早已在城市落脚。一场突如其来的野火把两人重新困在同一片土地上，他们不得不并肩守住最后一道防火带。火线之外，是父子之间十年未说出口的争执与亏欠。',
    poster:
      'https://readdy.ai/api/search-image?query=Western%20drama%20poster%20artwork%2C%20two%20men%20silhouetted%20against%20a%20massive%20grassland%20wildfire%2C%20orange%20embers%20in%20a%20smoky%20amber%20sky%2C%20dusty%20cowboy%20hats%2C%20no%20text%2C%20vertical%20composition%2C%20gritty%20film%20grain&width=480&height=720&seq=poster-film-11&orientation=portrait',
  },
  {
    id: 'film-12',
    category: 'movie',
    title: '蓝色回廊',
    subtitle: 'The Blue Corridor',
    year: 2026,
    region: '英国',
    genres: ['悬疑', '剧情'],
    rating: 8.9,
    director: 'Eleanor Hayes',
    cast: ['Clara Wynn', 'Julian Reed', 'Mabel Frost'],
    duration: '117分钟',
    popularity: 89,
    featured: true,
    summary: '一间永远走不到尽头的蓝色走廊，藏着疗养院所有人共同遗忘的夏天。',
    synopsis:
      '海边疗养院的东翼有一条被封锁的蓝色走廊。新来的夜班护士克莱拉发现，每当午夜钟声响起，走廊就会比白天长出十几米。她循着墙上褪色的照片一路向前，走进了一段被全院默契遗忘的往事：三十年前那个炎热夏天，究竟是谁没有走出这条走廊。',
    poster:
      'https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20poster%20artwork%2C%20a%20long%20empty%20blue%20corridor%20with%20flickering%20wall%20lamps%20and%20faded%20photographs%2C%20a%20nurse%20silhouette%20at%20the%20far%20end%2C%20deep%20teal%20and%20moonlight%20tones%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-12&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20empty%20grand%20seaside%20sanatorium%20corridor%2C%20tall%20windows%20with%20pale%20blue%20light%2C%20faded%20wallpaper%2C%20long%20shadows%2C%20eerie%20calm%2C%20muted%20teal%20and%20cream%20palette%2C%20no%20text&width=1600&height=900&seq=hero-film-12&orientation=landscape',
  },
  {
    id: 'film-13',
    category: 'movie',
    title: '贝弗利幽灵',
    subtitle: 'The Beverly Ghost',
    year: 2022,
    region: '英国',
    genres: ['喜剧', '奇幻'],
    rating: 7.6,
    director: 'Tom Ashby',
    cast: ['Nigel Fox', 'Rosie Bell', 'Harry Dunn'],
    duration: '103分钟',
    popularity: 70,
    summary: '一位过气演员搬进古宅，发现屋里唯一的房客是个爱点评演技的老幽灵。',
    synopsis:
      '过气舞台剧演员奈杰尔用最后的积蓄买下一栋乡间古宅，打算安静地度过余生。可他很快发现，屋里住着一位两百年前的剧评人幽灵，对他的每一个动作都要打分。一人一鬼从互不相让到联手重排一出老戏，笑料不断，也悄悄解开了这座宅子最后的悬念。',
    poster:
      'https://readdy.ai/api/search-image?query=Whimsical%20British%20comedy%20poster%20artwork%2C%20faded%20country%20manor%20drawing%20room%20with%20a%20theatrical%20actor%20arguing%20with%20a%20translucent%20ghost%2C%20dusty%20amber%20lamplight%2C%20teal%20shadows%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-13&orientation=portrait',
  },
  {
    id: 'film-14',
    category: 'movie',
    title: '雪线以南',
    subtitle: 'South of the Snowline',
    year: 2024,
    region: '法国',
    genres: ['剧情', '爱情'],
    rating: 8.3,
    director: 'Camille Roux',
    cast: ['Élodie Marchand', 'Luc Bernard', 'Ana Petit'],
    duration: '119分钟',
    popularity: 72,
    summary: '气象站的最后一个冬天，两个陌生人用无线电交换了整个季节的心事。',
    synopsis:
      '阿尔卑斯山南麓的一座气象站即将关闭，研究员艾洛蒂留下完成最后一季观测。大雪封山的第三周，她的无线电里出现了一个陌生男声——来自山另一侧一间早已废弃的木屋。他们约定每晚十点通话，聊雪、聊失败、聊那些无法对身边人说的话。春天来临时，他们必须决定是否见上一面。',
    poster:
      'https://readdy.ai/api/search-image?query=French%20romantic%20drama%20poster%20artwork%2C%20a%20woman%20in%20a%20wool%20coat%20standing%20outside%20a%20snowbound%20weather%20station%2C%20snowflakes%20in%20blue%20twilight%2C%20warm%20window%20light%20behind%20her%2C%20no%20text%2C%20vertical%20composition%2C%20delicate%20film%20grain&width=480&height=720&seq=poster-film-14&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Alpine%20snowy%20mountain%20ridge%20at%20blue%20hour%2C%20isolated%20weather%20station%20with%20one%20warm%20lit%20window%2C%20vast%20white%20silence%2C%20cold%20blue%20tones%20with%20a%20hint%20of%20amber%2C%20no%20text&width=1600&height=900&seq=hero-film-14&orientation=landscape',
  },
  {
    id: 'film-15',
    category: 'movie',
    title: '午夜面包店',
    subtitle: 'Midnight Bakery',
    year: 2025,
    region: '日本',
    genres: ['治愈', '剧情'],
    rating: 8.7,
    director: '白石幸人',
    cast: ['小林遥', '松本修', '佐藤凛'],
    duration: '108分钟',
    popularity: 84,
    summary: '只在午夜营业的面包店，为每个失眠的人烤一份他们记忆里的味道。',
    synopsis:
      '城市角落有一家午夜十二点开门的面包店，店主从不多问客人来历，只请他们描述一个最想再吃一次的味道。加班到深夜的上班族、刚分手的舞者、忘记回家路的老先生，都在这里得到一只刚出炉的面包。而店主自己，也在等待一个再也不会来的客人。',
    poster:
      'https://readdy.ai/api/search-image?query=Japanese%20healing%20drama%20poster%20artwork%2C%20small%20midnight%20bakery%20with%20warm%20glowing%20windows%20on%20a%20quiet%20street%2C%20fresh%20bread%20on%20a%20wooden%20counter%2C%20soft%20amber%20light%20and%20deep%20blue%20night%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20tiny%20bakery%20storefront%20glowing%20at%20midnight%20in%20a%20narrow%20Japanese%20street%2C%20warm%20orange%20lamplight%20spilling%20onto%20wet%20pavement%2C%20deep%20blue%20night%2C%20steam%20from%20fresh%20bread%2C%20no%20text&width=1600&height=900&seq=hero-film-15&orientation=landscape',
  },
  {
    id: 'film-16',
    category: 'movie',
    title: '深海灯塔',
    subtitle: 'Lighthouse of the Deep',
    year: 2023,
    region: '日本',
    genres: ['动画', '奇幻'],
    rating: 9.0,
    director: '宫岛青',
    cast: ['花泽悠', '神谷透', '小野寺葵'],
    duration: '105分钟',
    popularity: 93,
    summary: '少年在海底遇见一座会发光的灯塔，也遇见了失踪多年的母亲。',
    synopsis:
      '海边小镇的少年悠斗，每年夏天都会潜到海底找一枚母亲留下的玻璃珠。今年他潜得比以往更深，看见了一座沉在海底的灯塔，塔里的灯还亮着。灯火照亮的地方，是一个由记忆构成的岛。悠斗在岛上遇见了母亲年轻时的模样，也第一次明白，有些告别需要亲口说完。',
    poster:
      'https://readdy.ai/api/search-image?query=Animated%20fantasy%20film%20poster%20artwork%2C%20a%20boy%20swimming%20toward%20a%20glowing%20lighthouse%20submerged%20in%20a%20deep%20blue%20ocean%2C%20jellyfish%20light%20and%20god%20rays%2C%20warm%20golden%20beacon%20contrasting%20teal%20water%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-16&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dreamlike%20underwater%20scene%2C%20a%20lighthouse%20glowing%20beneath%20the%20sea%2C%20schools%20of%20fish%20and%20light%20rays%20in%20deep%20teal%20water%2C%20golden%20beacon%20glow%2C%20animated%20film%20still%2C%20no%20text&width=1600&height=900&seq=hero-film-16&orientation=landscape',
  },
  {
    id: 'film-17',
    category: 'movie',
    title: '夏日信号',
    subtitle: 'Summer Signal',
    year: 2024,
    region: '日本',
    genres: ['爱情', '青春'],
    rating: 7.7,
    director: '川口直',
    cast: ['森川葵', '青木凉', '大西千秋'],
    duration: '101分钟',
    popularity: 76,
    summary: '高三最后一个暑假，两个天台上的少年用一面镜子交换了整个夏天的秘密。',
    synopsis:
      '高三的夏天，转学生葵发现对面楼顶总有人用镜子反光向她打招呼。她试着回应，于是两个从未说过话的人，开始用光信号交流。他们聊考试、聊想去的城市、聊不敢告诉任何人的恐惧。暑假结束前，葵决定走到那栋楼下，把镜子里的信号变成一句真实的问候。',
    poster:
      'https://readdy.ai/api/search-image?query=Japanese%20coming-of-age%20romance%20poster%20artwork%2C%20two%20teenagers%20on%20apartment%20rooftops%20exchanging%20mirror%20light%20at%20sunset%2C%20power%20lines%20and%20summer%20clouds%2C%20warm%20amber%20and%20cyan%20sky%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-17&orientation=portrait',
  },
  {
    id: 'film-18',
    category: 'movie',
    title: '无重力告白',
    subtitle: 'Weightless Confession',
    year: 2025,
    region: '韩国',
    genres: ['爱情', '剧情'],
    rating: 8.0,
    director: '郑河俊',
    cast: ['韩素妍', '李在勋', '朴多恩'],
    duration: '114分钟',
    popularity: 79,
    summary: '在离心机里训练的女飞行员，把每次失重都当成一次告白的练习。',
    synopsis:
      '准备首次太空任务的飞行员素妍，每天要在离心机里承受八倍重力。她在训练日志里写下想说的话，却从未寄出。同为候选人的在勋发现了这本日志，开始在每次训练结束后，用同样的方式回应她。两个人隔着失重与沉默，慢慢学会了在地面上说出口。',
    poster:
      'https://readdy.ai/api/search-image?query=Korean%20romantic%20drama%20poster%20artwork%2C%20a%20female%20pilot%20in%20a%20training%20suit%20inside%20a%20centrifuge%20pod%2C%20soft%20white%20light%20and%20steel%20blue%20shadows%2C%20reflective%20visor%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-18&orientation=portrait',
  },
  {
    id: 'film-19',
    category: 'movie',
    title: '复仇的第十三天',
    subtitle: 'Day Thirteen',
    year: 2023,
    region: '韩国',
    genres: ['动作', '惊悚'],
    rating: 7.9,
    director: '姜泰旭',
    cast: ['车武烈', '尹世罗', '金显佑'],
    duration: '116分钟',
    popularity: 81,
    summary: '他只有十三天，把当年那桩案子的所有参与者一个个找回来。',
    synopsis:
      '因一桩被掩盖的工地事故，车武烈的家人在同一天全部离世。十三年后，他带着一份写满名字的清单出狱，给自己十三天时间。每过一天，清单上就少一个名字，而城市的另一端，当年负责结案的检察官正在重新翻开那份卷宗。两条线在第十三天凌晨交汇。',
    poster:
      'https://readdy.ai/api/search-image?query=Korean%20revenge%20action%20poster%20artwork%2C%20a%20stoic%20man%20in%20a%20black%20coat%20walking%20through%20a%20rain-soaked%20industrial%20alley%2C%20cold%20blue%20light%20with%20orange%20sodium%20lamps%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-19&orientation=portrait',
  },
  {
    id: 'film-20',
    category: 'movie',
    title: '沙丘之外的海',
    subtitle: 'The Sea Beyond the Dunes',
    year: 2026,
    region: '印度',
    genres: ['剧情', '歌舞'],
    rating: 8.4,
    director: 'Arjun Mehta',
    cast: ['Ravi Kapoor', 'Meera Nair', 'Sana Iqbal'],
    duration: '148分钟',
    popularity: 77,
    summary: '沙漠村庄里从未见过海的女孩，带着一台收音机踏上寻找潮声的旅程。',
    synopsis:
      '在拉贾斯坦邦的沙漠村庄，女孩米拉从小听着收音机里的一段海浪声入睡。她相信那是母亲留给她的暗号。十六岁那年，她带着一台旧收音机和一张手绘地图，独自踏上了去海边的路。一路上她遇见赶驼人、流浪歌手和一位退休的灯塔看守，也终于明白海从来不只是水。',
    poster:
      'https://readdy.ai/api/search-image?query=Indian%20cinematic%20drama%20poster%20artwork%2C%20a%20young%20woman%20in%20a%20flowing%20orange%20veil%20standing%20on%20a%20golden%20sand%20dune%20holding%20a%20vintage%20radio%2C%20deep%20blue%20dusk%20sky%2C%20warm%20sunlit%20sand%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-20&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Vast%20Rajasthan%20desert%20dunes%20at%20dusk%2C%20a%20solitary%20traveler%20with%20a%20small%20radio%2C%20deep%20indigo%20sky%20with%20warm%20amber%20horizon%2C%20cinematic%20epic%20scale%2C%20no%20text&width=1600&height=900&seq=hero-film-20&orientation=landscape',
  },
  {
    id: 'film-21',
    category: 'movie',
    title: '画中客',
    subtitle: 'The Guest in the Painting',
    year: 2024,
    region: '中国台湾',
    genres: ['悬疑', '剧情'],
    rating: 8.2,
    director: '黄仲伦',
    cast: ['林书晴', '吴承翰', '许安'],
    duration: '113分钟',
    popularity: 75,
    summary: '修复古画的女技师，在颜料层下发现了一个和自己长得一模一样的人。',
    synopsis:
      '古画修复师林书晴接到一幅清末肖像画的修复委托。清理到第三层颜料时，她发现画中人物的五官与自己几乎完全重合，而画中人手里握着的，是她小时候遗失的一只木鸟。为了查清这幅画的来历，她回到祖父留下的老宅，也一步步走进家族最不愿被提及的那段往事。',
    poster:
      'https://readdy.ai/api/search-image?query=Art%20mystery%20poster%20artwork%2C%20a%20woman%20restorer%20examining%20an%20antique%20portrait%20under%20a%20single%20lamp%2C%20pigment%20dust%20in%20the%20air%2C%20warm%20amber%20light%20against%20deep%20ink%20blue%20shadows%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-21&orientation=portrait',
  },
  {
    id: 'film-22',
    category: 'movie',
    title: '星星搬运工',
    subtitle: 'The Star Mover',
    year: 2025,
    region: '中国大陆',
    genres: ['动画', '家庭'],
    rating: 8.8,
    director: '赵一鸣',
    cast: ['杨舟', '包小雨', '李知远'],
    duration: '96分钟',
    popularity: 86,
    summary: '小镇男孩发现，每晚的星星都是被一位老人用板车一颗颗推上天去的。',
    synopsis:
      '七岁的豆豆在睡不着的时候，看见一个老人推着板车经过窗前，车上装满了发光的小球。老人说自己是星星搬运工，负责把熄灭的星星重新点亮、推回天上。豆豆成了他的小帮手，也慢慢知道，老人搬运的其实是小镇上每个人快要忘记的心愿。',
    poster:
      'https://readdy.ai/api/search-image?query=Wholesome%20animated%20film%20poster%20artwork%2C%20a%20small%20boy%20helping%20an%20old%20man%20push%20a%20wooden%20cart%20full%20of%20glowing%20stars%20up%20a%20hill%2C%20deep%20blue%20night%20sky%2C%20warm%20golden%20glow%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-22&orientation=portrait',
  },
  {
    id: 'film-23',
    category: 'movie',
    title: '大暑',
    subtitle: 'Height of Summer',
    year: 2022,
    region: '中国大陆',
    genres: ['剧情', '文艺'],
    rating: 8.1,
    director: '章明远',
    cast: ['周立群', '沈秋', '陆小雨'],
    duration: '127分钟',
    popularity: 63,
    summary: '小镇最后一个夏天，一家即将关门的老影院放完了它最后一场电影。',
    synopsis:
      '南方小城的大暑天，开了三十年的红星影院接到拆迁通知。老板老周决定在关门前放完库存里最后三十七部胶片。来看电影的人越来越少，但每个人都带着自己的故事走进来：等待复读结果的少年、准备离开的放映员、三十年前在这里相识的一对老人。',
    poster:
      'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20art%20drama%20poster%20artwork%2C%20old%20single-screen%20cinema%20facade%20at%20dusk%20in%20summer%2C%20faded%20hand-painted%20posters%2C%20green%20foliage%20and%20warm%20amber%20neon%2C%20dusty%20nostalgic%20tone%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-23&orientation=portrait',
  },
  {
    id: 'film-24',
    category: 'movie',
    title: '极夜追光',
    subtitle: 'Chasing the Polar Light',
    year: 2026,
    region: '中国大陆',
    genres: ['冒险', '纪录剧情'],
    rating: 9.2,
    director: '秦朗',
    cast: ['高原', '沈默', '叶千秋'],
    duration: '131分钟',
    popularity: 95,
    summary: '四名科考队员在极夜中徒步八百公里，只为修复一座停摆的观测站。',
    synopsis:
      '南极进入极夜，一座位于内陆冰盖的观测站突然失联。四名科考队员组成的应急小组，必须在无日照、零下五十度的环境中徒步八百公里完成修复。他们带着有限的燃料和一台老旧的信标机，在漫长黑夜里互相确认彼此还活着，也一步步逼近那场事故的真相。',
    poster:
      'https://readdy.ai/api/search-image?query=Antarctic%20expedition%20poster%20artwork%2C%20four%20tiny%20figures%20with%20headlamps%20crossing%20an%20endless%20ice%20sheet%20under%20a%20green%20aurora%2C%20deep%20polar%20blue%20night%2C%20epic%20scale%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-24&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Antarctic%20ice%20sheet%20at%20polar%20night%20with%20dramatic%20green%20aurora%2C%20tiny%20expedition%20lights%20in%20the%20distance%2C%20deep%20blue%20snow%20shadows%2C%20cinematic%20epic%20landscape%2C%20no%20text&width=1600&height=900&seq=hero-film-24&orientation=landscape',
  },
  {
    id: 'film-25',
    category: 'movie',
    title: '逆流三十年',
    subtitle: 'Thirty Years Upstream',
    year: 2021,
    region: '中国大陆',
    genres: ['剧情', '年代'],
    rating: 8.6,
    director: '李怀山',
    cast: ['张国立民', '宋韵', '陈树'],
    duration: '142分钟',
    popularity: 68,
    summary: '一家内河航运公司的兴衰，载着三代人逆流而上的三十年。',
    synopsis:
      '1988 年，长江边的小航运社只有两条旧驳船。厂长周德海带着一群下岗工人重新起航，从运砂石做到集装箱班轮。三十年间，公司经历了改制、扩张与资金链断裂，周家三代人也在同一条江上做出了不同选择。江水一直向前，而他们始终在逆流而上。',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20artwork%2C%20old%20river%20barge%20on%20the%20Yangtze%20at%20misty%20dawn%2C%20workers%20silhouetted%20on%20deck%2C%20deep%20steel%20blue%20water%20and%20warm%20sunrise%20amber%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-25&orientation=portrait',
  },
  {
    id: 'film-26',
    category: 'movie',
    title: '钢铁与棉花',
    subtitle: 'Steel and Cotton',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '工业'],
    rating: 8.0,
    director: '胡建国',
    cast: ['王砚', '刘铮', '孙小满'],
    duration: '125分钟',
    popularity: 66,
    summary: '老钢厂改造成艺术区的前夜，两代工人用各自的方式与厂房告别。',
    synopsis:
      '东北老工业区，一座运行了六十年的钢厂即将整体搬迁，厂房会被改造为艺术空间。老焊工刘振国留下来做最后的设备封存，他的女儿则是负责改造方案的设计师。父女俩在空荡的车间里反复争执，也在每一台机床、每一块铭牌上，重新认出了彼此。',
    poster:
      'https://readdy.ai/api/search-image?query=Industrial%20drama%20poster%20artwork%2C%20two%20workers%20silhouetted%20inside%20a%20vast%20empty%20steel%20mill%2C%20dusty%20light%20beams%20through%20broken%20windows%2C%20rust%20orange%20and%20cold%20steel%20blue%20palette%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-26&orientation=portrait',
  },
  {
    id: 'film-27',
    category: 'movie',
    title: '迷航者',
    subtitle: 'The Drifter',
    year: 2023,
    region: '美国',
    genres: ['科幻', '冒险'],
    rating: 8.3,
    director: 'Miles Turner',
    cast: ['Ethan Ray', 'Sofia Kang', 'Leo Voss'],
    duration: '138分钟',
    popularity: 82,
    summary: '一艘失联四十年的殖民船突然回航，船上只有一个不肯下船的人。',
    synopsis:
      '深空殖民船「漫游者号」在失联四十年后突然出现在木星轨道，自动导航完好，生命维持系统正常，但整艘船上只有一名船员仍在活动。救援队登船后发现，这名船员坚持认为任务才刚刚开始，而船上所有的记录都指向同一件不可能的事。',
    poster:
      'https://readdy.ai/api/search-image?query=Space%20adventure%20poster%20artwork%2C%20a%20weathered%20colonization%20ship%20drifting%20past%20jupiter%2C%20single%20astronaut%20standing%20at%20an%20observation%20window%2C%20cold%20blue%20gas%20giant%20and%20amber%20warning%20lights%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-27&orientation=portrait',
  },
  {
    id: 'film-28',
    category: 'movie',
    title: '十二月的海',
    subtitle: 'The Sea in December',
    year: 2021,
    region: '法国',
    genres: ['爱情', '文艺'],
    rating: 8.5,
    director: ' Isabelle Fontaine',
    cast: ['Margaux Vidal', 'Théo Lambert', 'Jeanne Aubert'],
    duration: '110分钟',
    popularity: 61,
    summary: '诺曼底冬天的海边旅馆，两个错过彼此二十年的人再次登记入住。',
    synopsis:
      '诺曼底海岸的淡季，旅馆只剩下两位客人。男人每年十二月都会来住三天，女人则是二十年来第一次回到这里。他们曾在这个小镇度过一个夏天，此后再未联系。海风、空荡的餐厅和一杯温热的苹果酒，把两个人慢慢推回那个没有说完的话题。',
    poster:
      'https://readdy.ai/api/search-image?query=French%20romantic%20art%20film%20poster%20artwork%2C%20empty%20Normandy%20beach%20in%20winter%20with%20two%20distant%20figures%20in%20long%20coats%2C%20gray%20blue%20sea%20and%20soft%20amber%20hotel%20window%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-28&orientation=portrait',
  },
  {
    id: 'film-29',
    category: 'movie',
    title: '猎户座雨',
    subtitle: 'Orion Rain',
    year: 2025,
    region: '美国',
    genres: ['科幻', '爱情'],
    rating: 7.8,
    director: 'Chloe Bennett',
    cast: ['Noah Fields', 'Amara Ellis', 'Sam Cole'],
    duration: '107分钟',
    popularity: 78,
    summary: '流星雨降临的七十二小时里，两个陌生人共享了同一段被删除的记忆。',
    synopsis:
      '猎户座流星雨期间，一款记忆共享设备出现故障，把两个素不相识的用户连在了一起。他们能在对方的视角里看见世界，也能看见对方拼命想删掉的那段记忆。七十二小时后设备将自动重置，他们必须决定，是保留这段连接，还是各自回到原本的生活。',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20sci-fi%20poster%20artwork%2C%20two%20people%20lying%20on%20a%20rooftop%20under%20a%20meteor%20shower%2C%20glowing%20blue%20data%20particles%20around%20their%20temples%2C%20deep%20indigo%20night%20with%20amber%20streaks%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-29&orientation=portrait',
  },
  {
    id: 'film-30',
    category: 'movie',
    title: '最后一个夜班',
    subtitle: 'The Last Night Shift',
    year: 2026,
    region: '中国大陆',
    genres: ['惊悚', '悬疑'],
    rating: 7.6,
    director: '钟野',
    cast: ['邓一鸣', '苏芮', '李怀'],
    duration: '99分钟',
    popularity: 73,
    summary: '医院地下一层的值班员，在最后一个夜班接到了一通来自太平间的内线电话。',
    synopsis:
      '老楼即将停用，值班员邓一鸣被安排守最后一个夜班。凌晨两点十七分，地下一层的内线电话响起，来电显示是太平间的分机。他按规程去检查，却发现所有设备都好好的。回到值班室，电话再次响起，这一次，对方叫出了他的名字，并说出了他从未告诉过任何人的事。',
    poster:
      'https://readdy.ai/api/search-image?query=Horror%20thriller%20poster%20artwork%2C%20a%20dim%20hospital%20basement%20corridor%20with%20a%20single%20ringing%20wall%20phone%2C%20green%20emergency%20light%2C%20long%20dark%20shadows%2C%20deep%20teal%20and%20sickly%20amber%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-film-30&orientation=portrait',
  },
];